
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/about-fhs-africa",
      function () {
        return require("private-next-pages/africa/about-fhs-africa.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/about-fhs-africa"])
      });
    }
  